import React, { useState } from "react";
import { Link, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { footerCmsData } from "@/redux/cms/cmsSelectors";
import { markInternalNavigation } from "@/utils/attributionCapture";
import "./Footer.css";

const HomePageLinkFooter = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const cmsData = useSelector(footerCmsData);
  const navigate = useNavigate();

  const stateRoutePaths = {
    alabamaHomesForSale: "/al/auctions",
    alaskaHomesForSale: "/ak/auctions",
    arizonaHomesForSale: "/az/auctions",
    arkansasHomesForSale: "/ar/auctions",
    californiaHomesForSale: "/ca/auctions",
    coloradoHomesForSale: "/co/auctions",
    connecticutHomesForSale: "/ct/auctions",
    delawareHomesForSale: "/de/auctions",
    floridaHomesForSale: "/fl/auctions",
    georgiaHomesForSale: "/ga/auctions",
    hawaiiHomesForSale: "/hi/auctions",
    idahoHomesForSale: "/id/auctions",
    illinoisHomesForSale: "/il/auctions",
    indianaHomesForSale: "/in/auctions",
    iowaHomesForSale: "/ia/auctions",
    kansasHomesForSale: "/ks/auctions",
    kentuckyHomesForSale: "/ky/auctions",
    louisianaHomesForSale: "/la/auctions",
    maineHomesForSale: "/me/auctions",
    marylandHomesForSale: "/md/auctions",
    massachusettsHomesForSale: "/ma/auctions",
    michiganHomesForSale: "/mi/auctions",
    minnesotaHomesForSale: "/mn/auctions",
    mississippiHomesForSale: "/ms/auctions",
    missouriHomesForSale: "/mo/auctions",
    montanaHomesForSale: "/mt/auctions",
    nebraskaHomesForSale: "/ne/auctions",
    nevadaHomesForSale: "/nv/auctions",
    newHampshireHomesForSale: "/nh/auctions",
    newJerseyHomesForSale: "/nj/auctions",
    newMexicoHomesForSale: "/nm/auctions",
    newYorkHomesForSale: "/ny/auctions",
    northCarolinaHomesForSale: "/nc/auctions",
    northDakotaHomesForSale: "/nd/auctions",
    ohioHomesForSale: "/oh/auctions",
    oklahomaHomesForSale: "/ok/auctions",
    oregonHomesForSale: "/or/auctions",
    pennsylvaniaHomesForSale: "/pa/auctions",
    rhodeIslandHomesForSale: "/ri/auctions",
    southCarolinaHomesForSale: "/sc/auctions",
    southDakotaHomesForSale: "/sd/auctions",
    tennesseeHomesForSale: "/tn/auctions",
    texasHomesForSale: "/tx/auctions",
    utahHomesForSale: "/ut/auctions",
    vermontHomesForSale: "/vt/auctions",
    virginiaHomesForSale: "/va/auctions",
    washingtonHomesForSale: "/wa/auctions",
    westVirginiaHomesForSale: "/wv/auctions",
    wisconsinHomesForSale: "/wi/auctions",
    wyomingHomesForSale: "/wy/auctions",
  };

  const toggleView = (key) => {
    setExpandedSections((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const sortedLinks = [...(cmsData?.homesByState?.links || [])].sort();
  const itemsPerCol = expandedSections["homesByState"] ? 10 : 4;
  const totalCols = 5;

  const cols = [];
  for (let i = 0; i < totalCols; i++) {
    const startIndex = i * itemsPerCol;
    const endIndex = startIndex + itemsPerCol;
    cols.push(sortedLinks.slice(startIndex, endIndex));
  }

  return (
    <section
      id="homes-by-state-section"
      className="home-page-link-footer"
    // style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="container-fluid px-2">
        <div className="row">
          <div className="col-12">
            <div className="d-md-flex justify-content-start gap-4 align-items-end mb-3">
              <h3
                id="homes-by-state-header"
                className="footer-header-category mb-0"
                tabIndex="0"
              >
                {cmsData?.homesByState?.header || "Search for homes by state"}
              </h3>
              <span
                id="view-full-list-btn"
                onClick={() => navigate("/site-map")}
                role="button"
                tabIndex="0"
                className="view-full-list"
              >
                View full list
              </span>
            </div>

            {/* Desktop View */}
            <div id="homes-by-state-desktop" className="d-lg-block d-md-none d-none mt-2">
              <div className="row">
                {cols.map((col, colIndex) => (
                  <div
                    key={colIndex}
                    id={`homes-by-state-col-${colIndex + 1}`}
                    className="col-md mb-2"
                  >
                    {col.map((link) => {
                      const linkId = link
                        ?.trim()
                        ?.split(/\s+/)
                        .map((word, index) =>
                          index === 0
                            ? word.toLowerCase()
                            : word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase()
                        )
                        .join("");
                      const route = stateRoutePaths[linkId];

                      return (
                        <div key={link} className="">
                          <Link
                            id={`state-link-${linkId}`}
                            to={route || "#"}
                            className="text-decoration-none footer-link-home"
                            onClick={() => markInternalNavigation()}
                          >
                            {link}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>

              <div className="show-more pt-2">
                <span
                  id="show-more-states-btn"
                  onClick={() => toggleView("homesByState")}
                  role="button"
                  tabIndex="0"
                  aria-label="View more items"
                  className="show-more"
                >
                  {expandedSections["homesByState"] ? "Show Less" : "Show More"}
                </span>
                <img
                  src="/assets/images/home/Footer_ShowMore.svg"
                  alt="show-more"
                  style={{
                    margin: "0px 8px",
                    transform: expandedSections["homesByState"]
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                />
              </div>
            </div>
            {/* Mid Size devices View */}
             <div id="homes-by-state-desktop" className="d-lg-none d-md-block d-none mt-5">
              <div className="row">
                {cols.map((col, colIndex) => (
                  <div
                    key={colIndex}
                    id={`homes-by-state-col-${colIndex + 1}`}
                    className="col-md-4 mb-3"
                  >
                    {col.map((link) => {
                      const linkId = link
                        ?.trim()
                        ?.split(/\s+/)
                        .map((word, index) =>
                          index === 0
                            ? word.toLowerCase()
                            : word.charAt(0).toUpperCase() +
                            word.slice(1).toLowerCase()
                        )
                        .join("");
                      const route = stateRoutePaths[linkId];

                      return (
                        <div key={link} className="">
                          <Link
                            id={`state-link-${linkId}`}
                            to={route || "#"}
                            className="text-decoration-none footer-link-home"
                            onClick={() => markInternalNavigation()}
                          >
                            {link}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>

              <div className="show-more pt-2">
                <span
                  id="show-more-states-btn"
                  onClick={() => toggleView("homesByState")}
                  role="button"
                  tabIndex="0"
                  aria-label="View more items"
                  className="show-more"
                >
                  {expandedSections["homesByState"] ? "Show Less" : "Show More"}
                </span>
                <img
                  src="/assets/images/home/Footer_ShowMore.svg"
                  alt="show-more"
                  style={{
                    margin: "0px 8px",
                    transform: expandedSections["homesByState"]
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                />
              </div>
            </div>
            {/* Mobile View */}
            <div id="homes-by-state-mobile" className="d-md-none">
              {sortedLinks
                .slice(0, expandedSections["homesByState"] ? 50 : 8)
                .map((link) => {
                  const linkId = link
                    ?.trim()
                    ?.split(/\s+/)
                    .map((word, index) =>
                      index === 0
                        ? word.toLowerCase()
                        : word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                    )
                    .join("");
                  const route = stateRoutePaths[linkId];

                  return (
                    <div key={link} className="mb-2">
                      <Link
                        id={`mobile-state-link-${linkId}`}
                        to={route || "#"}
                        className="text-decoration-none footer-link"
                        onClick={() => markInternalNavigation()}
                      >
                        {link}
                      </Link>
                    </div>
                  );
                })}

              <div className="show-more pt-2">
                <span
                  id="show-more-states-mobile-btn"
                  onClick={() => toggleView("homesByState")}
                  role="button"
                  tabIndex="0"
                  aria-label="View more items"
                  className="show-more"
                >
                  {expandedSections["homesByState"]
                    ? "Show Less"
                    : "Show More"}
                </span>
                <img
                  src="/assets/images/home/Footer_ShowMore.svg"
                  alt="show-more"
                  style={{
                    margin: "0px 8px",
                    transform: expandedSections["homesByState"]
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomePageLinkFooter;
